/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnnouncementDto } from '../../models/announcement-dto';

export interface GetAnnouncement$Params {
}

export function getAnnouncement(http: HttpClient, rootUrl: string, params?: GetAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<AnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, getAnnouncement.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnnouncementDto>;
    })
  );
}

getAnnouncement.PATH = '/api/v1/announcement';
